import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./index.scss"

export default function PersonCard({ person }) {
  const {
    name,
    jobPosition,
    linkToJobPage,
    gridImage,
    hiringSquare,
    profileImage,
    slug,
  } = person

  return (
    <div className="col-md-3 person-card">
      {hiringSquare ? (
        <div className="person-card__inner hiring-square">
          <Link to={linkToJobPage}>
            <div className="person-card__image">
              <GatsbyImage image={getImage(gridImage)} alt={name} />
            </div>
            <h5>{name}</h5>
            <p>{jobPosition}</p>
          </Link>
        </div>
      ) : (
        <div className="person-card__inner">
          <Link to={`/about/team/${slug}`}>
            <div className="person-card__image">
              <GatsbyImage
                image={getImage(gridImage)}
                alt={name}
                className="reg-img"
              />
              <GatsbyImage
                image={getImage(profileImage)}
                alt={name}
                className="hover-img"
              />
            </div>
            <h5>{name}</h5>
            <p>{jobPosition}</p>
          </Link>
        </div>
      )}
    </div>
  )
}
